import styled from 'styled-components'
import textLink, { textLinkWithHover } from '../styles/textLink'
import Image from './Image'
import Background from './layout/Background'
import Container, { getMaxElementWidthInRem } from './layout/Container'
import Link from './Link'

function FeaturedInvestigationWithStories( { investigation, stories } ) {
  return (
    <Background color="blueGrey__light">
      <Container>
        <StyledFeaturedInvestigationBlock>
          <StyledInvestigation>
            <p>Featured</p>
            <h4>{ investigation.title }</h4>
            <div 
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={ { __html: investigation.introCopy } } 
            />
            <StyledInvestigationLinks>
              <Link href={ `/investigations/${ investigation.slug }` }>
                View investigation
              </Link>
              <Link href="/investigations">
                View all
              </Link>
            </StyledInvestigationLinks>
          </StyledInvestigation>
          { stories.map( story => story.mainImage.length > 0 && (
            <StoryCard
              key={ story.id }
              story={ story }
            />
          ) ) }
        </StyledFeaturedInvestigationBlock>
      </Container>
    </Background>
  )
}

function StoryCard( { story } ) {
  const image = story.mainImage[ 0 ]

  return (
    <StyledStory>
      <Link href={ `/stories/${ story.slug }` }>
        <StyledStoryImage>
          <Image
            src={ image.url }
            alt={ image.imageAltText }
            layout="fill"
            objectFit="cover"
            sizes={ `
              ( max-width: 599px ) 87vw, 
              ( max-width: 899px ) calc( 43.5vw - 2rem ), 
              min( ${ getMaxElementWidthInRem( { cols: 3, gutter: 2 } ) }rem, calc( 29vw - 4rem ) )
            ` }
          />
        </StyledStoryImage>
        <h5>{ story.title }</h5>
      </Link>
    </StyledStory>
  )
}

const StyledFeaturedInvestigationBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin: -1rem -1rem 3rem;
  padding: 1rem 0;

  > * {
    margin: 1rem 1rem;
  }

  @media ( min-width: 600px ) {
    grid-template-columns: repeat( 2, 1fr );

    > *:first-child {
      grid-column: 1/3;

      > * {
        max-width: 25rem;
      }
    }
  }

  @media ( min-width: 900px ) {
    grid-template-columns: repeat( 3, 1fr );

    > *:first-child {
      grid-column: 1/2;
    }
  }
`

const StyledInvestigation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: 1rem;

  > p {
    margin: 0;
    ${ p => p.theme.typo.generalSansSemiBold };
    color: ${ p => p.theme.colors.red };
  }

  > h4 {
    margin: 1rem 0 0.75rem;
    ${ p => p.theme.typo.generalSansSemiBold };
    font-size: ${ p => p.theme.typo.sizes.medium };
    color: ${ p => p.theme.colors.black };
  }

  > div p:last-child {
    margin-bottom: 0;
  }
`

const StyledInvestigationLinks = styled.div`
  margin: 0.8rem -0.4rem 0;

  a {
    display: inline-block;
    padding: 0.2rem 0;
    margin: 0 0.4rem;
    ${ p => p.theme.typo.generalSans };
    font-size: ${ p => p.theme.typo.sizes.small };
    color: ${ p => p.theme.colors.blueGrey__deep };
    ${ textLinkWithHover }

    &:first-child {
      ${ p => p.theme.typo.generalSansSemiBold };
      color: ${ p => p.theme.colors.black };
    }
    
    &:last-child {
      text-decoration-color: currentColor;
    }
  }
`

const StyledStoryImage = styled.div`
  position: relative;
  padding-bottom: 70%;
  background: ${ p => p.theme.colors.black };

  img {
    transition: opacity .3s ease-out;
  }
`

const StyledStory = styled.div`
  position: relative;
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  h5 {
    max-width: 25rem;
    margin: 1rem 0 0;
    ${ p => p.theme.typo.generalSansSemiBold };
    font-size: ${ p => p.theme.typo.sizes.normal };
    ${ textLink }
    text-decoration-color: transparent;
    transition: text-decoration-color .3s ease-out;
  }

  a:hover {
    h5 {
      text-decoration-color: ${ p => p.theme.colors.red };
    }
    
    ${ StyledStoryImage } {
      img {
        filter: grayscale( 1 );
        opacity: 0.9;
      }
    }
  }
`

export default FeaturedInvestigationWithStories
